var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 75,
    viewBox: "0 0 90 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1855 70.6689C24.8965 70.6689 10.0171 55.7891 10.0171 37.5C10.0171 19.2109 24.8965 4.33154 43.1855 4.33154C49.3838 4.33154 55.4287 6.05225 60.668 9.30713L59.6133 11.0063C54.6904 7.94775 49.0107 6.33154 43.1855 6.33154C25.999 6.33154 12.0171 20.3135 12.0171 37.5C12.0171 54.6865 25.999 68.6689 43.1855 68.6689C60.3721 68.6689 74.3545 54.6865 74.3545 37.5C74.3545 34.396 73.8994 31.3311 73.0029 28.3906L74.915 27.8066C75.8701 30.9365 76.3545 34.1978 76.3545 37.5C76.3545 55.7891 61.4746 70.6689 43.1855 70.6689Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.603 39.083C37.875 39.083 34.0283 35.2363 34.0283 30.5078C34.0283 25.7798 37.875 21.9331 42.603 21.9331C47.3311 21.9331 51.1777 25.7798 51.1777 30.5078C51.1777 35.2363 47.3311 39.083 42.603 39.083ZM42.603 23.9331C38.9775 23.9331 36.0283 26.8823 36.0283 30.5078C36.0283 34.1333 38.9775 37.083 42.603 37.083C46.2285 37.083 49.1777 34.1333 49.1777 30.5078C49.1777 26.8823 46.2285 23.9331 42.603 23.9331Z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0049 52.0664H55.0049V48.5703C55.0049 44.9961 50.3467 44.0215 48.8252 43.7988L43.1855 50.0654L37.5464 43.7988C36.0249 44.0215 31.3672 44.9961 31.3672 48.5703V52.0664H29.3672V48.5703C29.3672 43.6904 34.9258 41.9736 37.8652 41.7471L38.356 41.709L43.1855 47.0752L48.0156 41.709L48.5068 41.7471C51.4463 41.9736 57.0049 43.6904 57.0049 48.5703V52.0664Z",
    fill: "#A4A4A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1805 32.8854C63.7983 31.0942 60.6549 28.4954 58.8273 25.1495C57.5594 22.8281 57.3923 20.9201 57.3799 20.7426V9.26455L68.1814 6.69678L78.983 9.26455V20.7235C78.9399 21.392 78.2352 28.7619 68.1805 32.8854Z",
    fill: "#E20909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1631 25.6416L61.5713 21.4248L62.9248 19.9521L66.0049 22.7803L73.7207 13.9258L75.2285 15.2402L66.1631 25.6416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsAuthentication);
export default __webpack_public_path__ + "static/media/aboutUsAuthentication.deb75b3e08fa2bbad9c73fa61af0600a.svg";
export { ForwardRef as ReactComponent };